import { IProjectConfiguration } from "../entities-generated/models/project/project-configuration";
import { IProjectSelectionRequest } from "../entities-generated/models/project/project-selection-request";
import { IStormDoorHandleModel } from "../entities-generated/models/storm-door/storm-door-handle-model";
import { ApiClient } from "./shop-api-client";

class ShopStormHandleApiClientClass {
  public getSelectedStormDoorHandle(doorInstallationId: string) {
    return ApiClient.get<IStormDoorHandleModel>(`shop/install-plans/${doorInstallationId}/handles/storm-door/selected`);
  }

  public getStormDoorHandleOptions(doorInstallationId: string) {
    return ApiClient.get<IStormDoorHandleModel[]>(`shop/install-plans/${doorInstallationId}/handles/storm-door`);
  }

  public selectStormDoorHandle(request: IProjectSelectionRequest) {
    return ApiClient.patch<IProjectConfiguration>(`shop/handles/storm-door/select`, request);
  }
}

export const ShopStormHandleApiClient = new ShopStormHandleApiClientClass();